import hostLayoutStoreFactory from "./host-layout";
import hostUserProfileFactory from "./host-userProfile";
import hostDialogsFactory from "./host-dialogs";
import hostInboxStoreFactory from "./host-teamless-inbox";

export default function initVuexHostStores( teamlessInboxFeatureFlag = false ) {
	hostLayoutStoreFactory();
	hostUserProfileFactory();
	hostDialogsFactory();

	if ( teamlessInboxFeatureFlag ) {
		hostInboxStoreFactory();
	}
}
